import React from "react";
import FactorTabTable from "./FactorTabTable";
import FactorsImage from "./FactorsImage";
import { Box } from "@mui/material";
import { GetSaleInformationSaleItems } from "../../../models/settlement.model";
import TabsEmptyStyle from "../../permission/components/TabsEmptyStyle";

interface FactorItemsTabProps {
  saleData: GetSaleInformationSaleItems;
}

const FactorItemsTab = ({ saleData }: FactorItemsTabProps) => {
  if (saleData?.items?.length === 0 && !saleData?.invoiceFiles) {
    return (
      <TabsEmptyStyle
        height="100%"
        completeText="موردی به اقلام فاکتور اضافه نشد"
      />
    );
  }
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "30px",
        overflowY: "auto",
        height: "100%",
      }}
    >
      {saleData?.items?.length > 0 && (
        <Box>
          <FactorTabTable saleItems={saleData?.items} />
        </Box>
      )}
      {saleData?.invoiceFiles && (
        <Box>
          <FactorsImage invoiceFiles={saleData?.invoiceFiles} />
        </Box>
      )}
    </div>
  );
};

export default FactorItemsTab;
